import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../constants/URL";

//GET TERMINAL STUDENTS (without terminal entries)
export const getTerminalStudents = (data) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal/students`,
      JSON.stringify(data),
      config
    );

    return res.data.data;
  } catch (err) {
    toast.error(err.response?.data?.message || "Error fetching students");
    return false;
  }
};

//CREATE TERMINAL ENTRIES
export const createTerminal = (data) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal`,
      JSON.stringify(data),
      config
    );

    toast.success("Terminal entries created successfully");
    return true;
  } catch (err) {
    toast.error(
      err.response?.data?.message || "Error creating terminal entries"
    );
    return false;
  }
};

//GET TERMINAL ENTRIES
export const getTerminal = (data) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal/get`,
      JSON.stringify(data),
      config
    );

    return res.data.data;
  } catch (err) {
    toast.error(
      err.response?.data?.message || "Error fetching terminal entries"
    );
    return false;
  }
};

//GET TERMINAL BY STUDENT
export const getTerminalByStudent = (data) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal/student`,
      JSON.stringify(data),
      config
    );

    return res.data.data;
  } catch (err) {
    toast.error(
      err.response?.data?.message || "Error fetching student terminal entries"
    );
    return false;
  }
};

//UPDATE TERMINAL ENTRIES
export const updateTerminal = (id, data) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.patch(
      `${BASE_URL}/api/terminal/${id}`,
      JSON.stringify(data),
      config
    );

    toast.success("Terminal entries updated successfully");
    return true;
  } catch (err) {
    toast.error(
      err.response?.data?.message || "Error updating terminal entries"
    );
    return false;
  }
};

//DELETE TERMINAL ENTRY
export const deleteTerminal = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${BASE_URL}/api/terminal/${id}`);

    toast.success("Terminal entry deleted successfully");
    return true;
  } catch (err) {
    toast.error(err.response?.data?.message || "Error deleting terminal entry");
    return false;
  }
};
